import PackagesPopularDestinations from './PackagesPopularDestinations';

export default PackagesPopularDestinations;
